import { Link } from '@inertiajs/react';
import { Button, Image } from '@mantine/core';

import { useMediaQuery } from '@/hooks/useMediaQuery';

export default function NavbarLogo({ className, label = 'Kali' }: { className?: string; label?: string }) {
  const { isMobile } = useMediaQuery();

  return (
    <Button
      component={Link}
      href='/'
      aria-label={label}
      variant='subtle'
      color='gray'
      h='auto'
      px={isMobile ? 8 : 16}
      py={4}
      className={className}
      style={{ flexShrink: 0 }}
    >
      <Image src='/images/logo.png' alt='Kali' h={28} w='auto' />
    </Button>
  );
}
